import { render, staticRenderFns } from "./RevealV2WelcomePanel.vue?vue&type=template&id=4fc1f9a6&scoped=true"
import script from "./RevealV2WelcomePanel.vue?vue&type=script&lang=js"
export * from "./RevealV2WelcomePanel.vue?vue&type=script&lang=js"
import style0 from "./RevealV2WelcomePanel.vue?vue&type=style&index=0&id=4fc1f9a6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc1f9a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fc1f9a6')) {
      api.createRecord('4fc1f9a6', component.options)
    } else {
      api.reload('4fc1f9a6', component.options)
    }
    module.hot.accept("./RevealV2WelcomePanel.vue?vue&type=template&id=4fc1f9a6&scoped=true", function () {
      api.rerender('4fc1f9a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/cfdeRevealV2/RevealV2WelcomePanel.vue"
export default component.exports